import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import { useNavigate } from 'react-router-dom';
import EditEducation from './components/EditEducation';
// import { Form }from 'antd'

import { useDispatch, useSelector } from 'react-redux';

import {
  //   hobbies_list,
  //   sports_list,
  //   maritialStatus,
  createFamilyDetails,
  countryCodes,
  // occupationData,
  // familyStatus,
  // familyValue,
  // familyType,
  // siblings_maritial_Status,
  education_list,
  department_list,
  cities_list,
  stateCodes,
  get_byID,
  currencyCodes,
  education_level_list
  // signup
} from './redux/slice';
import { pageview } from '../../utilities/gtag';

const index = () => {
  useEffect(() => {
    document.title =
      'Educational background – Update Career & Education details';
  }, []);
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    country_codes,
    // Occupation_Data,
    // maritial_Status,
    // family_Status,
    // family_Value,
    // family_Type,
    // siblings_maritialStatus,
    // get_hobbies_list,
    // get_sports_list
    education_details,
    department_details,
    city_details
  } = useSelector((state) => state.editprofile);
  const { currency_data } = useSelector((state) => state.editpartner);
  const { state_details, education_level_listdata } = useSelector(
    (state) => state.editeducation
  );
  const { user_data } = useSelector((state) => state.listDashboard);

  useEffect(() => {
    get_listby_id();
    get_currency();
    // get_hobbies();
    // get_sports();
    // get_maritialStatus();
    get_countryCodes();
    // get_countryCodes();
    // get_occupation();
    // get_familyStatus();
    // get_familyValue();
    // get_familyType();
    // get_siblings_maritialStatus();
    get_education_details();
    get_department_details();
    get_cities();
    get_states();
    get_education_level_list();
  }, []);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  const get_listby_id = () => {
    const payload = userId;
    dispatch(get_byID(payload));
  };
  const get_countryCodes = () => {
    dispatch(countryCodes());
  };

  const get_currency = () => {
    dispatch(currencyCodes());
  };

  const get_education_details = () => {
    dispatch(education_list());
  };
  const get_department_details = () => {
    dispatch(department_list());
  };
  const get_cities = () => {
    dispatch(cities_list());
  };

  const get_states = () => {
    dispatch(stateCodes());
  };

  const get_education_level_list = () => {
    dispatch(education_level_list());
  };

  const onsubmit = async (values) => {
    console.log('onsubmit', values);
    // dispatch(createAboutme(payload));

    // const payload = formData;
    const payload = {
      height_ft: values.height_ft,
      height_in: values.height_in,
      is_disabled:
        values.is_disabled === '' ? false : Boolean(values.is_disabled),
      marital_status_id: values.marital_status_id,
      hobby_interests: values.hobby_interests.map((id) => ({
        hobby_sport_id: id
      })),
      sport_interests: values.sport_interests.map((id) => ({
        hobby_sport_id: id
      })),
      other_interests: values.other_interests,
      self_description: values.self_description
    };
    // dispatch(createAboutme(payload)
    try {
      console.log('Form Submitted:', payload);
      const response = await dispatch(createFamilyDetails(payload)).unwrap(); // Dispatch Redux action
      if (response?.success) {
        localStorage.setItem('profile_id', response.profile_id); // Store profile ID
        navigate(`/editfamily/${response.profile_id}`); // Redirect on success
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  //   try {
  //     const response = await dispatch(createAboutme(payload)).unwrap();
  //     if (response?.profile_id) {
  //       localStorage.setItem('profile_id', response.profile_id); // Store in localStorage
  //       navigate(`/editFamilydetails/${response.profile_id}`); // Redirect to edit page
  //     }
  //   } catch (error) {
  //     console.error('Error submitting:', error);
  //   }
  // };
  // console.log('user_data', user_data);
  return (
    <>
      <Layout sider={true}>
        <EditEducation
          education_list={education_details}
          department_details={department_details}
          country_codes={country_codes}
          city_details={city_details}
          state_details={state_details}
          onsubmit={onsubmit}
          user_data={user_data}
          currency_data={currency_data}
          education_level_listdata={education_level_listdata}
        />
      </Layout>
    </>
  );
};

export default index;
